import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  formControl: {
    justifyContent: 'center'
  },
  controlLabel: {
    marginRight: theme.spacing(2)
  },
  renewalChangesBlocked: {
    textTransform: 'none',
    fontWeight: 400,
    maxWidth: 320
  },
  container: {
    maxWidth: 530,
    alignItems: 'center',
    gap: theme.spacing(4)
  },
  datePicker: {
    marginLeft: theme.spacing(6),
    marginBottom: 0,
    maxWidth: 180
  }
});

export default makeStyles(styles);
